import { Tooltip as MuiTooltip, withStyles } from '@material-ui/core'
import React, { FC, ReactElement, useMemo } from 'react'
import styled from 'styled-components'

import { RewardsLevel } from '../../../../../../../graphql/search'
import { rewardsLevelsInfo } from '../../../../../../../lib/rewards/levels'

export interface TierTooltipProps {
  className?: string
  children: ReactElement
  level: RewardsLevel
}

const Tooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: '#ffffff',
    maxWidth: 498,
    borderRadius: '4px',
    border: 'none',
    boxShadow: '0 0 20px -6px #29282875',
    padding: '24px',
  },
}))(MuiTooltip)

const Content = styled.div``

const Text = styled.div`
  font-size: 20px;
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.text.secondary};
  line-height: 23px;
  margin-top: 16px;
  &:first-child {
    margin-top: 0;
  }
`

const Percentage = styled.span`
  color: ${({ theme }) => theme.colors.text.primary};
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  font-size: 20px;
  font-weight: bold;
  text-align: right;
  display: inline-block;
  width: 70px;
  margin-right: 24px;
`

export const TierTooltip: FC<TierTooltipProps> = ({ children, className, level }) => {
  const tierInfo = useMemo(() => rewardsLevelsInfo.find((info) => info.level === level), [level])
  if (!tierInfo) {
    return null
  }
  return (
    <Tooltip
      className={className}
      title={
        <Content>
          <Text>
            <Percentage>{tierInfo.benefits.vipDiscountPercentage.toFixed(1)}%</Percentage> VIP
            Discount on in-practice order
          </Text>
          <Text>
            <Percentage>{tierInfo.benefits.commissionsPercentage.toFixed(1)}%</Percentage>{' '}
            Commissions on patient-direct sales
          </Text>
          <Text>
            <Percentage>{tierInfo.benefits.rebatePercentage.toFixed(1)}%</Percentage> Monthly rebate
            (excludes PL orders)
          </Text>
        </Content>
      }
      placement="bottom"
      interactive
    >
      {children}
    </Tooltip>
  )
}
